module.exports = __webpack_public_path__ + "img/calculator.58d759c.png";